import Link from '@mui/material/Link';
import Typography from '@mui/material/Typography';
import type { ReactElement } from 'react';
import { Trans } from 'react-i18next';

import { houzyContact } from '../../../lib/houzyContact';

export function SupportPrompt(): ReactElement {
    return (
        <Typography variant="body2">
            {/* Tag names must not collide with HTML void elements (br, img, link, ...) */}
            <Trans
                i18nKey="AUTH.NEED_HELP"
                components={{
                    supportLink: <Link href={`mailto:${houzyContact.infoEmail}`} color="primary" underline="hover" />,
                }}
            />
        </Typography>
    );
}
